export const Wordmark = ({ size = "text-[21px]", logo = "h-[22px]" }) => (
  <span className="group inline-flex items-center gap-2.5" data-testid="wordmark">
    <img src="/tq-logo.png?v=3" alt="TradrQuant" className={`${logo} w-auto transition-transform duration-300 group-hover:scale-105`} />
    <span className={`tq-wordmark text-[#ECEBE4] ${size}`}>
      Tradr<span className="tq-q">Q</span>uant
    </span>
  </span>
);
